export const USERS_UPDATE_LIST = "USERS_UPDATE_LIST";
export const USERS_UPDATE_LIST_METHOD = "USERS_UPDATE_LIST_METHOD";
export const USERS_UPDATE_PREVIEW = "USERS_UPDATE_PREVIEW";
export const USERS_UPDATE_FORM = "USERS_UPDATE_FORM";
export const USERS_UPDATE_INPUT_FORM = "USERS_UPDATE_INPUT_FORM";

export const updateUsersList = ({ users, count }) => ({
  type: USERS_UPDATE_LIST,
  payload: { users, count }
});
export const updateUsersListMethod = (method, data) => ({
  type: USERS_UPDATE_LIST_METHOD,
  payload: { method, data }
});

export const updateUsersPreview = (preview = null) => ({
  type: USERS_UPDATE_PREVIEW,
  payload: { preview }
});

export const updateForm = (form = null) => ({
  type: USERS_UPDATE_FORM,
  payload: { form }
});
export const updateInputForm = (name, value) => ({
  type: USERS_UPDATE_INPUT_FORM,
  payload: { name, value },
});